export const boxExpired = (userData) => {
  let isExpired = false;
  if (userData && userData.subscriptions) {
    if (!userData.subscriptions.live.length) {
      isExpired = true;
    }
  }
  return isExpired;
};
